import { Accordion, Card, Col, Row, Label, InputField, PrimaryButton, Rating, Tooltip, AttachmentCommonUpload, Callout, OutlineButton, PopupDialogbox, Alert } from "client/CommonComponents";
import "./TransferAsset.scss";
import informationImage from "../../../../../../assets/images/Rating Info.svg";
import { formatPrice, isNumberWithOneDecimal, isNumberWithoutDecimal } from "utils";
import { CONSTANTS } from "client/utils/constants";
import AssetNumber from "client/Components/OrderManagement/AssetNumber/AssetNumber-Container";
import deleteOrder from '../../../../../../assets/images/Delete New.svg';
import plus from '../../../../../../assets/images/Plus New.svg'
import ReceivingBranch from "../ReceivingBranch";
import RatingInfo from "./RatingInfo/RatingInfo";
import GetAttachmentView from "client/CommonComponents/AttachmentView";
import permissions, { isAuthorized } from "client/utils/Permissions";

interface IProps {
  handleCommentchanges?: any,
  onChangeOdometerHourMeter?: any,
  handleClickCart?: any,
  handleAssetBtn?: any
  isAssetBtnClicked?: any,
  setIsAssetBtnClicked?: any,
  informationList?: any,
  informationConditionList?: any,
  onChangeRating?: any,
  assetDetailList?: any;
  setAssetDetailList?: any;
  onClickAdd?: any;
  onClickDelete?: any;
  handleRatingChange?: any;
  rating?: any;
  addToCart?: any;
  handleKeyPress?: any;
  documentList?: any;
  setDocumentList?: any,
  onCloseLinkAttachment?: any,
  onClicktLinkAttachment?: any,
  isAttachmentBtnClicked?: any,
  attachmentsList?: any,
  onChangeLinkAttachment?: any,
  attachmentError?: any;
  onUploadClick?: any;
  getLinkedAttachmentsCount?: any;
  onRemoveAttachment: any;
  setAttachmentError?: any;
  Popupcontent?: any,
  hideDialog?: any,
  isEditOrder?: any,
  transferOrderByIdData?: any,
  cancelRequestOnClick?: any,
  revertChangesOnClick?: any,
  getOdometerLabel?: any;
  getVinSerialLabel?: any;
  TransferAssetFieldRef?: any;
  setIsAsserNumberValid?: any;
  setAddToCart?: any;
  popupPrimarybtnOnclick?: any;
  docList?: any;
  addNewAssetAlert?: boolean;
  setAddNewAssetAlert?: any;
  validate?: any;
  validatereceivingCostCenter?: any;
  transferAssets?: any;
  showCart?: boolean;
  isHourMeterField?: any;
  formatOdometerOnBlur?: any;
}

const InformativeField = ({ label, value }: any) => (
  <div className="info-wrapper">
    <div className="label">{label}</div>
    <div className="value">{value}</div>
  </div>
);
const ratingContent = [
  {
    ratingValue: 1,
    value: 'Poor (1)'
  },
  {
    ratingValue: 2,
    value: 'Fair (2)'
  },
  {
    ratingValue: 3,
    value: 'Good (3)'
  },
  {
    ratingValue: 4,
    value: 'Very Good (4)'
  },
  {
    ratingValue: 5,
    value: 'New / Excellent (5)'
  }
]
const TransferAsset = (props: IProps) => {
  const {
    assetDetailList,
    setAssetDetailList,
    onClickAdd,
    onClickDelete,
    isAssetBtnClicked,
    setIsAssetBtnClicked,
    addToCart,
    handleCommentchanges,
    onChangeOdometerHourMeter,
    informationList,
    informationConditionList,
    handleClickCart,
    documentList,
    setDocumentList,
    onCloseLinkAttachment,
    onClicktLinkAttachment,
    isAttachmentBtnClicked,
    attachmentsList,
    onChangeLinkAttachment,
    attachmentError,
    onUploadClick,
    getLinkedAttachmentsCount,
    getOdometerLabel,
    onRemoveAttachment,
    setAttachmentError,
    Popupcontent,
    hideDialog,
    isEditOrder,
    transferOrderByIdData,
    cancelRequestOnClick,
    revertChangesOnClick,
    getVinSerialLabel,
    TransferAssetFieldRef,
    setIsAsserNumberValid,
    setAddToCart,
    popupPrimarybtnOnclick,
    docList,
    addNewAssetAlert,
    setAddNewAssetAlert,
    validate,
    validatereceivingCostCenter,
    transferAssets,
    showCart,
    isHourMeterField,
    formatOdometerOnBlur
  } = props;

  const expandedItems: any = []
  assetDetailList?.forEach((asset: any, index: any) => {
    const toolTipOverallCondition = {
      onRenderContent: () => {
        return <RatingInfo isOverAllCondition={true} RatingValue={Number(asset?.conditionRating)} />
      }
    }
    const item = {
      headerText: (
        <div className={`heading-container ${asset?.isExist ? 'added-to-cart' : 'not-added-to-cart'}`}>
          <div className='heading-container-subItem'>
            <span><b>ITEM # :{asset?.assetIndex + 1}</b></span>
          </div>
          <div className='right-heading-dispostion'>
            {asset?.isValid ? '' : <span className="error-reason me-2">Asset is  required</span>}
            <img src={deleteOrder} alt='Delete Order' className='me-2'
              onClick={() => onClickDelete(asset)}
              onKeyDown={(e: any) => { if (e.key === 'Enter') onClickDelete(asset) }}
              tabIndex={0}
            />
          </div>
        </div>
      ),
      content: <>
        <div className="p-3">
          <ReceivingBranch
            asset={asset}
            setAssetDetailList={setAssetDetailList}
            assetDetailList={assetDetailList}
            validateReceivingCostCenter={validatereceivingCostCenter}
            validate={validate}
          />
          <Row>
            <Col xs={12} sm={4} md={4} lg={4} className="mb-sm-2 mb-3">
              <AssetNumber
                order={asset}
                setOrder={setAssetDetailList}
                addToCart={addToCart}
                setAddToCart={setAddToCart}
                setIsAsserNumberValid={setIsAsserNumberValid}
                assetDetailList={assetDetailList}
                setIsAssetBtnClicked={setIsAssetBtnClicked}
                isAssetBtnClicked={isAssetBtnClicked}
                inputRef={(element: any) => TransferAssetFieldRef.current[0] = element}
              />
            </Col>

            <Col xs={12} sm={4} md={4} lg={4} className="mb-sm-2 mb-3">
              {asset?.glCategory !== CONSTANTS.TRAILERS && <>
                <Label required data-attribute="TransferAsset_Default_Label">{getOdometerLabel(asset)}</Label>
                <InputField
                  name='odometerHourMeter'
                  value={asset?.odometerHourMeter}
                  onChange={(e: any) => onChangeOdometerHourMeter(e, asset)}
                  onBlur={(event: any) => formatOdometerOnBlur(event, asset)}
                  onKeyPress={(event: any) => {
                    isHourMeterField(asset) 
                      ? isNumberWithoutDecimal(event)
                      : isNumberWithOneDecimal(event)
                  }}
                  className={(asset.odometerHourMeterError?.length ? "controlValidation" : "")}
                 data-attribute="TransferAsset_odometerHourMeter_Input" />
                {asset.odometerHourMeterError ? <p className='validMessage'>{asset.odometerHourMeterError}</p> : ""}</>
              }
            </Col>

            <Col xs={12} sm={4} md={4} lg={4} className="mb-sm-2 mb-3 px-1">
              <ul className='information-list'>
                {informationList.map((item: any, index: any) =>
                  <li key={index}><span>{item.text}</span></li>
                )}
              </ul>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={8} md={8} lg={8} className="mb-3">
              <div className="asset-information-block">
                <Label data-attribute="TransferAsset_Default_Label_2">Asset Information</Label>
                <div>
                  <span id={"link_attachment_" + index} tabIndex={0} onKeyDown={(e: any) => { if (e.key === 'Enter') onClicktLinkAttachment(e, index) }} onClick={(e: any) => { onClicktLinkAttachment(e, index) }} className='link-attachment me-0 mb-2'>
                    <span className='fa fa-paperclip attachment-img'> </span> Link Attachment to Item ({getLinkedAttachmentsCount(asset)})
                  </span>
                  {isAttachmentBtnClicked?.[index] && (
                    <Callout
                      targetId={"link_attachment_" + index}
                      toggleIsCalloutVisible={(e: any) => onClicktLinkAttachment(e, index)}
                      calloutMaxHeight={300}
                     data-attribute="TransferAsset_Default_Callout">
                      <GetAttachmentView
                        attachmentsList={docList}
                        onCloseLinkAttachment={onCloseLinkAttachment}
                        onChangeLinkAttachment={onChangeLinkAttachment}
                        itemType={asset} />
                    </Callout>
                  )}
                </div>
              </div>
              <div className="asset-info-section mt-1 transfer">
                <Row>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <InformativeField label="Unit#" value={(asset?.unitNumber != null && asset?.unitNumber?.trim()?.length != 0) ? asset?.unitNumber : '-'} />
                    <InformativeField label="Description" value={(asset?.description != null && asset?.description?.trim()?.length != 0) ? asset?.description : '-'} />
                    <InformativeField label="Color" value={(asset?.color != null && asset?.color?.trim()?.length != 0) ? asset?.color : '-'} />
                    <InformativeField label={getVinSerialLabel(asset)} value={(asset?.serialNumber != null && asset?.serialNumber?.trim()?.length != 0) ? asset?.serialNumber : '-'} />
                    <InformativeField label="Monthly Payment" value={(typeof asset?.monthlyAmount == "number" && asset?.monthlyAmount != null) ? `$${parseFloat(`${asset?.monthlyAmount}`).toFixed(2)}` : '-'} />
                    <InformativeField label="Months Remaining" value={(asset?.monthRemaining != null) ? asset?.monthRemaining : '-'} />
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <InformativeField label="Year" value={(asset?.modelYear != null) ? asset?.modelYear : '-'} />
                    <InformativeField
                      label="Equipment Status"
                      value={(asset?.eqStatusDesc != null && asset?.eqStatusDesc?.trim()?.length != 0) ? asset?.eqStatusDesc : '-'}
                    />
                    <InformativeField
                      label="Equipment Class"
                      value={(asset?.equipmentClassDesc != null && asset?.equipmentClassDesc != 0) ? asset?.equipmentClassDesc : '-'}
                    />
                    <InformativeField label="License #" value={(asset?.licensePlateNumber != null && asset?.licensePlateNumber?.trim()?.length != 0) ? asset?.licensePlateNumber : '-'} />
                    <InformativeField label="Net Booked Value" value={(typeof asset?.netBookedValue == "number" && asset?.netBookedValue != null) ? `$${formatPrice(asset?.netBookedValue, 2)}` : '-'} />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <Row className="margin-spacing">
                <Col xs={12} className="mb-3 px-1">
                  <Label required className="mb-0" data-attribute="TransferAsset_Default_Label_3">Overall Condition</Label>
                  <div className='rating-info'>
                    <div>
                      <Rating
                        rating={asset?.conditionRating} 
                        onChange={(e: any, rating: any) => props?.onChangeRating(rating, asset)}
                        allowZeroStars  data-attribute="TransferAsset_Default_Rating" />
                      {
                        ratingContent.map((item: any, _index: any) =>
                          <>
                            {asset?.conditionRating == item.ratingValue ? <span className="text-rating">{item.value}</span> : null}
                          </>
                        )
                      }
                    </div>
                    <Tooltip tooltipProps={toolTipOverallCondition} id='RatingTooltip' data-attribute="TransferAsset_Default_Tooltip">
                      <img src={informationImage} alt="info" title='Rating Info' className="rating-tooltip" />
                    </Tooltip>
                  </div>
                  {asset.overallConditionError ? <p className='validMessage'>{asset.overallConditionError}</p> : ""}
                  <span className="comment-star">
                    ("Comment" is required, If less than or equals 3 star)
                  </span>
                </Col>
                <Col xs={12} className="mb-3 px-1">
                  <ul className='information-list'>
                    {informationConditionList.map((item: any, index: any) =>
                      <li key={index}><span>{item.text}</span></li>
                    )}
                  </ul>
                </Col>
                <Col xs={12} className="mb-3 px-1">
                  <Label required={asset?.conditionRating <= 3} data-attribute="TransferAsset_Default_Label_4">Overall Condition Comment</Label>
                  <InputField
                    name='conditionComment'
                    value={asset?.conditionComment}
                    onChange={(e: any) => handleCommentchanges(e, asset)}
                    multiline={true}
                    row={6}
                    resizable={false}
                    className={'conditionalComment ' + (asset.overallConditionCommentError?.length ? "controlValidation" : "")}
                   data-attribute="TransferAsset_conditionComment_Input" />
                  {asset.overallConditionCommentError ? <p className='validMessage'>{asset.overallConditionCommentError}</p> : ""}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </>,
      uuid: `transferAssetDetails_${index}`,
      key: asset?.assetIndex
    }
    expandedItems.push(item)
  })

  //sorting child items(reasons) as last in first out order
  const sortedChildItemsLIFO = expandedItems?.sort((a: any, b: any) => b?.key - a?.key)
  return (<div className="item-details-requisition disposition mt-3 mb-3">
    <Card data-attribute="TransferAsset_Default_Card">
      <div className='header border-bottom'>
        <div className="left-content">
          <p className='headingText'>ASSET INFORMATION <span>({assetDetailList?.length})</span></p>
          <p className='subText enter-asset'>Enter Asset #</p>
        </div>
        <div className="right-content">
          <div className="asset-qty asset-qty-disposition">
            <img className="add-asset-button-plus" src={plus} alt="add asset" onClick={(item: any) => onClickAdd(item)} tabIndex={0} onKeyDown={(e: any) => { if (e.key === 'Enter') onClickAdd(e); }} />
            <div className={`attachment-container ms-2 mt-0`} >
              <div className="pull-right">
                <AttachmentCommonUpload
                  link={true}
                  list={documentList}
                  setList={setDocumentList}
                  multiple={true}
                  uploadBtnClick={onUploadClick}
                  error={attachmentError}
                  maxSize={5}
                  onRemove={onRemoveAttachment}
                  uploadedList={attachmentsList}
                  tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                  setError={setAttachmentError}
                  iAttachmentEditable={true}
                  isDownloadable={false}
                  disabled={!isAuthorized(permissions.CreateUpdateTransfers)}
                 data-attribute="TransferAsset_Default_AttachmentCommonUpload" />
              </div>
            </div>
          </div>
        </div>
        {
          addNewAssetAlert &&
          <Alert
            className="alert-message warningAlert"
            showAlert={addNewAssetAlert}
            dismissAlert={() => setAddNewAssetAlert(false)}
            type="warning"
            text="New Asset Quantity added."
           data-attribute="TransferAsset_Default_Alerts" />
        }
      </div>
      <Accordion
        Items={sortedChildItemsLIFO}
        preExpanded={["transferAssetDetails_0"]}
        allowZeroExpanded
        className="custom-accordion"
       data-attribute="TransferAsset_Default_Accordion" />
      <Row>
        <Col xs={12} md={12} lg={12} className="transfer-asset-content pull-right">
          <div className='cancel-edit-btn reactivation'>
            {
              (isEditOrder || transferOrderByIdData?.orderStatus?.includes('Pending Approval')) && <PrimaryButton className='ml-2' text='Revert Changes' onClick={() => { revertChangesOnClick() }}
              disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}               data-attribute="TransferAsset_Default_Button" />
            }
            {
              (isEditOrder || transferOrderByIdData?.orderStatus?.includes('Pending Approval')) && <OutlineButton text='Cancel Request' onClick={() => { cancelRequestOnClick() }} disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}  data-attribute="TransferAsset_Default_Button_2" />
            }
          </div><PrimaryButton text={(showCart && transferAssets?.length) ? "Update to Cart" : 'Add to Cart'} 
          className='addCart-transfer' onClick={handleClickCart}
          disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}
           data-attribute="TransferAsset_Default_Button_3" />
        </Col>
      </Row>
    </Card>
    {Popupcontent.isDialogVisible ?
      <PopupDialogbox
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={hideDialog}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
        popupPrimarybtnOnclick={(
          item: any,
          actionby: string,
          value: any
        ) => {
          popupPrimarybtnOnclick(
            item,
            actionby,
            value
          );
        }}
       data-attribute="TransferAsset_Default_PopupDilalogBox" /> : ""}
  </div>);
};

export default TransferAsset;
